//全局默认配置项

//默认路由地址
export const DEFAULT_ROUTE = "/home";

//暂未开放的页面列表
export const noneOpenList = ["/teach"];

//埋点统计路由列表
export const trackStatisticList = ["/secondary/grade", "/secondary/setting", "/flight/guide"];

//登录系统的地址
export const AUTH = "/gateway/unpapi/uotssimulator/oauth2";

export const tokenStr = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxODk2ODA5NzA0NDY3MzIwODMyIiwibmJmIjoxNzkxODU3MDg1LCJleHAiOjE3OTQ0NDkwODUsImlhdCI6MTc5MTg1NzA4NX0.hBvWrQel8t3MPB2T4kcjDepvyOTsViTogth7D0pmtX4"

